import React from "react";

const Resume = () => {
    return(
        <>
        <div>
            <p>
                this is the resume page
            </p>
        </div>
        </>
    )
}

export default Resume;
